<div class="layout-auto-1">
  <div></div>
  <div class="content md3-surface">
    <div class="layout-list-quickfilter md3-card-on-surface">
      <!-- Search Header -->
      <exg-search-bar (Search)="messageTable.search($event)" [placeholder]="getRessource('SearchHolder')"
                      class="span-layout">
        <ng-template #rightTemplate>
          <i (click)="messageTable.loadData()" class="search-action fal fa-sync"></i>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fal fa-filter"
                 [class.fas]="messageTable.uiFilterAktiv(1).length > 0"
                 [class.fal]="messageTable.uiFilterAktiv(1).length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCmessageTableFilterControl
                              (onActivateFilter)="messageTable.pageChanged(1);popup.close()"
                              [MetaInfo]="messageTable.MetaInfo"
                              [showFilter]="true" [uiFilter]="messageTable.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="messageTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action fal fa-sort-alt"
                 [class.fas]="messageTable.uiSortAktiv().length > 0"
                 [class.fal]="messageTable.uiSortAktiv().length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter  #VCmessageTableSortControl
                               (onActivateFilter)="messageTable.pageChanged(1);popup.close()"
                              [MetaInfo]="messageTable.MetaInfo"
                              [showSort]="true" [uiFilter]="messageTable.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="messageTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <app-exg-dropdown >
            <ng-template #hostTemplate>
              <i class="search-action fal fa-binoculars"
                 [class.fas]="messageTable.uiFilterAktiv(2).length > 0"
                 [class.fal]="messageTable.uiFilterAktiv(2).length === 0"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCmessageTableSearchControl
                              (onActivateFilter)="messageTable.pageChanged(1);popup.close()"
                              [MetaInfo]="messageTable.MetaInfo"
                              [showSearch]="true" [uiFilter]="messageTable.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="messageTable.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <i class="search-action fal fa-gears"
             [class.disabled]="!messageTable.newV2Table"
             (click)="openTableSettings($event)">
          </i>
          <exg-table-settings #tableDefinitionSettings
                              [tableDef]="messageTable.tableDefinition"
                              [metaInfo]="messageTable.MetaInfo"
                              localStorageID="messageTable">
          </exg-table-settings>
          <i class="search-action fa-table"
             (click)="messageTable.newV2Table = !messageTable.newV2Table;"
             [class.fas]="messageTable.newV2Table"
             [class.fal]="!messageTable.newV2Table">
          </i>
        </ng-template>
      </exg-search-bar>
      <div class="content">
        <ng-container *ngIf="!messageTable.newV2Table">
          <exg-data-table #VCmessageTable (ItemSelect)="messageTable.selectedRow"

                          (RowChange)="messageTable.selectionChanged($event)" [allowSingleSelection]="true"
                          [displayState]="messageTable.state"
                          [rowSource]="messageTable.data"
                          containerClass="grid cols-15"
                          [selectKey]="messageTable.selectKey"
                          (RowDblClick)="messageTable.dblClick($event)">
            <ng-template #headerTemplate>

              <div>
                <p><strong></strong></p>
              </div>
              <div class="span-2">
                <p><strong>{{enumSvc.getFieldCaption('Nachricht', 'msg_enmIdent_NachrichtTyp')}}</strong></p>
                <p><strong>{{enumSvc.getFieldCaption('Nachricht', 'msgAbsender')}}</strong></p>
              </div>
              <div class="span-2">
                <p><strong>{{enumSvc.getFieldCaption('Nachricht', 'msgDatum')}}</strong></p>
                <p><strong>{{enumSvc.getFieldCaption('Nachricht', 'msgZeit')}}</strong></p>
              </div>
              <div class="span-8">
                <p><strong>{{enumSvc.getFieldCaption('Nachricht', 'msgBetreff')}}</strong></p>
              </div>
              <div class="span-2">
                <p><strong>{{enumSvc.getFieldCaption('Nachricht', 'msgKategorie')}}</strong></p></div>
            </ng-template>
            <ng-template #rowTemplate let-row>
              <div>
                <p style="white-space: normal">
                  <i style="padding-right: 0.25rem" *ngIf="row.msgIsRead" class="fal fa-envelope-open"></i>
                  <i style="padding-right: 0.25rem" *ngIf="!row.msgIsRead" class="fal fa-envelope"></i>
                  <i style="padding-right: 0.25rem" *ngIf="row.msg_enmIdent_NachrichtPrio === 1" class="fal fa-chevron-double-down"></i>
                  <i style="padding-right: 0.25rem" *ngIf="row.msg_enmIdent_NachrichtPrio === 2" class="fal fa-equals"></i>
                  <i style="padding-right: 0.25rem" *ngIf="row.msg_enmIdent_NachrichtPrio === 3" class="fal fa-chevron-double-up"></i>
                  <i style="padding-right: 0.25rem" *ngIf="row.hasAttachment" class="fal fa-paperclip"></i>
                  <i style="padding-right: 0.25rem" *ngIf="row.msgFIN" class="fal fa-check"></i>
                  <i style="padding-right: 0.25rem" *ngIf="row.msgSmartfix" class="fal fa-location-arrow"></i>
                </p>
              </div>
              <div class="span-2">
                <p>{{enumSvc.getEnumerationText(row.msg_enmName_NachrichtTyp, row.msg_enmIdent_NachrichtTyp)}}</p>
                <p>{{row.msgAbsender}}</p>
              </div>
              <div class="span-2">
                <p>{{row.msgCRD | excDate:'Globals.DateFormat' }}</p>
                <p>{{row.msgCRD | excDate:'HH:mm:ss' }}</p>
              </div>
              <div class="span-8">
                <p style="white-space: normal">
                  {{row.msgBetreff}}
                </p>
              </div>
              <div class="span-2">
                <p>{{enumSvc.getEnumerationText(row.msgNachrichtKategorie_enmName,
                                                row.msgNachrichtKategorie_enmIdent)}}
                </p></div>
            </ng-template>
          </exg-data-table>
        </ng-container>
        <ng-container *ngIf="messageTable.newV2Table">
          <exg-table #VCmessageTableV2
                     (RowDblClick)="messageTable.dblClick($event)"
                     (RowChange)="messageTable.selectionChanged($event)"
                     (FilterActivation)="messageTable.loadData()"
                     [selectKey]="messageTable.selectKey"
                     [rowSource]="messageTable.data"
                     [tableDef]="messageTable.tableDefinition"
                     [distinctTableName]="'Messages'"
                     [metaInfo]="messageTable.MetaInfo"
                     [displayState]="messageTable.state"
                     class="content"
                     [allowMultiSelection]="false"
                     [allowSingleSelection]="true"
                     (loadDistinct)="messageTable.getDistinctData($event)"
                     [distinctData]="messageTable.distinctData">
          </exg-table>
        </ng-container>
      </div>
      <div class="app-drawer">
        <i class="search-filter-action fal fa-chevron-right"
           (click)="openMail()"
           [tooltip]="getRessource('openWorkspace')" flow="left"
           [class.disabled]="messageTable.isLoading || !messageTable.selectedRow">
        </i>
        <ng-container *ngIf="isAIActive()">
          <i class="search-filter-seperator"></i>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-filter-action fal fa-brain-circuit"
                 [tooltip]="'KI'" flow="left">
              </i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <div class="content">
                <ng-container>
                <div *ngIf="!AIQueue?.processing" class="md-menu-item" (click)="startKIAgent(); popup.close()">
                  Automatische Mailzuordnung starten
                </div>
                <div *ngIf="AIQueue?.processing" class="md-menu-item">
                  Automatische Mailzuordnung läuft bereits
                </div>
                </ng-container>
              </div>
            </ng-template>
          </app-exg-dropdown>
        </ng-container>
      </div>
      <exg-pager (PageChange)="messageTable.pageChanged($event)" *ngIf="!init"
                 [pagingSource]="messageTable.paging"
                 class="span-layout">
        <ng-template #leftTemplate>
          <app-exg-dropdown  *ngIf="!messageTable.isLoading"
            class="typo-small" [list]="preFilterDefinition" elementclass="typo-left" maxHeight="250px"
                            [label]="selectedMod.caption" position="abovecenter" listdisplay="caption"
                            [disabled]="!this.excSecurity.isFeatured('EISUSR')"
                            (change)="changePreFilterMod($event.value)"
                            [adaptiveHeightActive]="true"
                            [adaptiveHeightOffset]="250">
          </app-exg-dropdown>
          <app-exg-dropdown *ngIf="!messageTable.isLoading && selectedMod?.types.length > 0"
                            class="typo-small" [list]="selectedMod.types" elementclass="typo-left" maxHeight="250px"
                            [label]="selectedType.caption" position="abovecenter" listdisplay="caption"
                            (change)="changePreFilterType($event.value)"
                            [adaptiveHeightActive]="true"
                            [adaptiveHeightOffset]="250"
          >
          </app-exg-dropdown>
        </ng-template>
        <ng-template #rightTemplate>
          <div class="app-pager-chips">
            <app-exg-filter-chips #VCFilterChips
                                  [inputDataTable]="messageTable"
                                  [VCFilterControl]="{ VCFilter: VCmessageTableFilterControl, VCSearch: VCmessageTableSearchControl, VCSort: VCmessageTableSortControl}">
            </app-exg-filter-chips>
          </div>
        </ng-template>
      </exg-pager>
    </div>
  </div>
</div>
